import { ApplicationState, AppThunkDispatch } from '../../store';
import Footer, { FooterStateProps, FooterDispatchProps } from './Footer';
import { connect } from 'react-redux';

const mapStateToProps = (state: ApplicationState): FooterStateProps => ({
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): FooterDispatchProps => ({
});

export default connect<FooterStateProps, FooterDispatchProps, void, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(Footer as any);